import { useState } from 'react';
import type { TISAUser } from '@/types/tisa-coins';

interface Props {
  students: TISAUser[];
}

export function QuickActionsSection({ students }: Props) {
  const [showManualXP, setShowManualXP] = useState(false);
  const [showBadgeAward, setShowBadgeAward] = useState(false);

  return (
    <div className="bg-gray-900/50 border-2 border-purple/30 rounded-xl p-6">
      <h2 className="text-xl font-cinzel font-bold text-purple mb-4">
        ⚡ Quick Actions
      </h2>

      <div className="space-y-3">
        <button
          onClick={() => setShowManualXP(!showManualXP)}
          className="w-full px-4 py-3 bg-emerald/20 text-emerald border-2 border-emerald/50 rounded-lg font-bold hover:bg-emerald/30 transition-all"
        >
          ✨ Award Manual XP
        </button>

        <button
          onClick={() => setShowBadgeAward(!showBadgeAward)}
          className="w-full px-4 py-3 bg-purple/20 text-purple border-2 border-purple/50 rounded-lg font-bold hover:bg-purple/30 transition-all"
        >
          🏆 Award Badge
        </button>

        <button className="w-full px-4 py-3 bg-blue-500/20 text-blue-300 border-2 border-blue-500/50 rounded-lg font-bold hover:bg-blue-500/30 transition-all">
          📋 Create Quest
        </button>

        <button className="w-full px-4 py-3 bg-gold/20 text-gold border-2 border-gold/50 rounded-lg font-bold hover:bg-gold/30 transition-all">
          💰 Manual Coin Adjustment
        </button>
      </div>

      <div className="mt-6 pt-6 border-t border-gray-700/50">
        <p className="text-xs text-gray-400 text-center mb-2">Student Count</p>
        <p className="text-3xl font-orbitron font-black text-center text-white">{students.length}</p>
      </div>
    </div>
  );
}
